import { bearerAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "./logo.svg";

export const digitalOcean = defineConnector({
  identifier: "digitalOcean",
  name: "DigitalOcean",
  tagLine: "Cloud infrastructure provider",
  logo,
  protocol: "http",
  tags: ["engineering"],
  defaultUrlPattern: () => "https://api\\.digitalocean\\.com/.*",
  auth: (app) => bearerAuth(app.secret.apiKey),
  steps: [
    {
      title: "Get your DigitalOcean API token",
      items: [
        {
          kind: "markdown",
          content:
            "Visit your [DigitalOcean API Tokens](https://cloud.digitalocean.com/account/api/tokens) page and generate a new **Personal Access Token**.",
        },
      ],
    },
    {
      title: "Enter your API token",
      items: [
        {
          kind: "input",
          label: "Personal Access Token",
          placeholder: "dop_v1_...",
          required: true,
          target: { kind: "secrets", field: "apiKey" },
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: () => "https://api.digitalocean.com/v2/account",
  },
});
